"use strict";

import onInitModulesInsScope from "./onInitModulesInScope";

/**
 * Bereits eingebundene externe Loader-Scripts. Ein Loader (z. B. TOMAS TWebShop) darf pro URL
 * nur einmal pro Seite geladen werden, auch wenn mehrere Widgets auf derselben Seite stehen.
 */
const loadedScripts = [];

/** Der CookiebotOnAccept-Listener gilt seitenweit und darf nur einmal registriert werden. */
let cookiebotAcceptListenerRegistered = false;

/**
 * Prüft, ob alle vom Service verlangten Consent-Kategorien erteilt sind. Mehrere Kategorien
 * werden als kommaseparierter String übergeben und müssen dann alle erteilt sein.
 */
function getServicePermission(service) {
    let consent = service;
    // Parse the consent string into an array if it contains commas
    if (consent.indexOf(',') > -1) {
        consent = consent.split(',');
    }
    // Determine if all consent categories are accepted
    let allConsentsGranted = true;

    if (Array.isArray(consent)) {
        // Iterate through each required consent category
        for (const consentCategory of consent) {
            if (!Cookiebot.consent[consentCategory]) {
                allConsentsGranted = false;
                break;
            }
        }
    } else {
        allConsentsGranted = !!Cookiebot.consent[consent];
    }

    return allConsentsGranted;
}

/**
 * Fail-closed: fehlt Cookiebot oder der Service, gilt der Consent als nicht erteilt.
 */
function hasServiceConsent(service) {
    return typeof Cookiebot !== 'undefined' && !!service && getServicePermission(service);
}

/**
 * Bindet die externen Scripts der übergebenen Container ein. Wird ausschließlich nach erteiltem
 * Consent aufgerufen – vorher findet keine Verbindung zum Drittanbieter statt.
 */
function injectConsentScripts($containers) {
    $containers.each(function () {
        let $container = $(this);
        let src = $container.data('script-src');

        if (!src) {
            return;
        }

        // Die Widget-Konfiguration muss im globalen Scope liegen, bevor der Loader ausgeführt wird
        let configVar = $container.data('script-config-var');
        let config = $container.data('script-config');

        if (configVar && config) {
            window[configVar] = $.extend(true, {}, window[configVar] || {}, config);
        }

        if (loadedScripts.indexOf(src) > -1) {
            return;
        }
        loadedScripts.push(src);

        let script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.setAttribute('data-cookieconsent', 'marketing');
        document.body.appendChild(script);
    });
}

/**
 * Schaltet einen einzelnen Script-Block frei: Overlay ausblenden und externes Script einbinden.
 */
function revealScriptBlock($wrapper) {
    injectConsentScripts($wrapper.find('.js-consent__script'));

    let $overlay = $wrapper.find('.js-consent__overlay');

    if ($overlay.length !== 0) {
        $overlay.attr('hidden', 'hidden');
    }
    $wrapper.removeClass('consent--box-shadow');
}

/**
 * Der Consent gilt seitenweit und nicht pro Widget: nach einer Zustimmung müssen alle
 * Script-Blöcke der Seite erscheinen, nicht nur der angeklickte. Jeder Block wird gegen
 * seinen eigenen data-consent-service geprüft, damit Blöcke mit weitergehenden Anforderungen
 * (z. B. 'marketing,statistics') verdeckt bleiben, solange diese nicht erfüllt sind.
 */
function revealConsentedScriptBlocks(grantedService) {
    $('.js-consent[data-consent-type="script"]').each(function () {
        let $wrapper = $(this);
        let service = $wrapper.data('consent-service');

        // grantedService wird beim Klick auf einen Zustimmungs-Button uebergeben. Bloecke mit
        // identischer Anforderung erscheinen dann sofort, ohne den Umweg ueber Cookiebot.consent:
        // submitCustomConsent() aktualisiert den Consent-Status nicht zwingend synchron, ein
        // Abgleich unmittelbar nach dem Klick wuerde daher noch 'nicht erteilt' liefern.
        if (service === grantedService || hasServiceConsent(service)) {
            revealScriptBlock($wrapper);
        }
    });
}

/**
 * Zustimmung über die Cookiebot-Bar statt über unseren Overlay-Button: Widgets ohne Reload
 * nachladen. Ein Listener genügt für die ganze Seite.
 */
function registerCookiebotAcceptListener() {
    if (cookiebotAcceptListenerRegistered) {
        return;
    }
    cookiebotAcceptListenerRegistered = true;

    // Bewusst gekapselt: als direkter Listener wuerde das Event-Objekt als grantedService ankommen
    window.addEventListener('CookiebotOnAccept', function () {
        revealConsentedScriptBlocks();
    });
}

export function init() {
    onInitModulesInsScope(function initInScope($scope) {

        let $cookieConsentButtons = $('.js-consent__accept-btn');

        $cookieConsentButtons.each(function(){
            let $cookieConsentButton = $(this);
            let service = $cookieConsentButton.closest('.js-consent').data('consent-service');
            let type = $cookieConsentButton.closest('.js-consent').data('consent-type');
            let overlay = $cookieConsentButton.closest('.js-consent__overlay');
            var wrapper = $cookieConsentButton.closest('.js-consent');

            if (type === 'iframe' || type === 'tour'  || type === 'foto') {
                let wrapper = $cookieConsentButton.closest('.js-consent');
                let iframe = wrapper.find('.js-consent__iframe');
                let src = iframe.data('iframe-src');
                let overlay =$cookieConsentButton.closest('.js-consent__overlay');

                if(getServicePermission(service)){
                    iframe.prop('src', src);
                    if(overlay.length !== 0){
                        overlay.attr("hidden", "hidden");
                        wrapper.removeClass("consent--box-shadow");
                        wrapper.removeClass("embed-responsiv");
                        wrapper.removeClass("embed-responsive-16by9");
                    }
                }else{
                    if(overlay.length !== 0){
                        overlay.attr("hidden", false);
                        wrapper.addClass("consent--box-shadow");
                    }
                    if(type === 'foto') {
                        window.addEventListener('CookiebotOnAccept', function (e) {
                            if (overlay.length !== 0 && Cookiebot.consent.marketing) {
                                window.location.reload();
                            }
                        });
                    }
                    $cookieConsentButton.on('click', function(e){
                        setServicePermission(service);
                        iframe.prop('src', src);
                        if(overlay.length !== 0){
                            overlay.attr("hidden", "hidden");
                            wrapper.removeClass("consent--box-shadow");
                        }
                        if(type === 'tour') {
                            window.addEventListener('CookiebotOnAccept', function (e) {
                                if (overlay.length !== 0) {
                                    overlay.attr("hidden", "hidden");
                                    wrapper.removeClass("consent--box-shadow");
                                    window.location.reload();
                                }
                            });
                        }
                    });


                }
            } else if (type === 'script') {
                registerCookiebotAcceptListener();

                if (hasServiceConsent(service)) {
                    revealScriptBlock(wrapper);
                } else {
                    if (overlay.length !== 0) {
                        overlay.attr("hidden", false);
                        wrapper.addClass("consent--box-shadow");
                    }

                    $cookieConsentButton.on('click', function (e) {
                        setServicePermission(service);
                        // Nicht nur diesen Block: die Zustimmung gilt für die ganze Seite
                        revealConsentedScriptBlocks(service);
                    });
                }
            } else {
                $cookieConsentButton.on('click', function (e) {
                    setServicePermission(service);
                });
            }
        });
        function setServicePermission(service) {
            let consent = service;
            // check if consent is a string with a comma
            if (consent.indexOf(',') > -1) {
                consent = consent.split(',');
            }
            // check if consent is an array
            if (Array.isArray(consent)) {
                let preferences = consent.indexOf('preferences') > -1;
                let statistics = consent.indexOf('statistics') > -1;
                let marketing = consent.indexOf('marketing') > -1;

                Cookiebot.submitCustomConsent(preferences, statistics, marketing);
            } else {
                let preferences = consent === 'preferences';
                let statistics = consent === 'statistics';
                let marketing = consent === 'marketing';

                Cookiebot.submitCustomConsent(preferences, statistics, marketing);
            }
            // app.initModules($cookieConsentButtons);
        }
    })
}

